import {
  CascadiaTypographyStyle,
  decorations,
  textStyles,
} from "@certn/cascadia-tokens";
import { css } from "@emotion/css";

export function getTextDecorationStyle(decoration: keyof typeof decorations) {
  switch (decoration) {
    case "font-deco-uppercase":
      return css({
        textTransform: "uppercase",
      });
    case "font-deco-underline":
      return css({
        textDecoration: "underline",
      });
  }
}

export function getTextStyle(
  style: CascadiaTypographyStyle = "global/body-primary"
) {
  const values = textStyles[style];

  return css(
    {
      fontSize: `var(--${values.size})`,
      fontWeight: `var(--${values.weight})`,
      lineHeight: `var(--${values.lineHeight})`,
      fontFamily: `var(--${values.fontFamily})`,
    },
    getTextDecorationStyle(values.decoration)
  );
}
